module.exports = __webpack_public_path__ + "img/complex_query.png";